import {
	formatContentDate,
	isContentUpdatedAfterPublish,
} from "@brookbush/services/utils/contentDates";

import { clsx } from "clsx";
import { CalendarIcon } from "lucide-react";

interface ContentDatesProps {
	createdAt: string;
	updatedAt: string;
	showIcon?: boolean;
	className?: string;
}

/**
 * Shows "Published: …", plus "Updated: …" when update is a later day.
 */
const ContentDates = ({
	createdAt,
	updatedAt,
	showIcon = false,
	className,
}: ContentDatesProps) => {
	const showUpdated = isContentUpdatedAfterPublish(createdAt, updatedAt);

	return (
		<p
			className={clsx(
				"flex flex-wrap items-center gap-x-2 gap-y-1 font-medium text-base",
				className,
			)}
		>
			{showIcon ? <CalendarIcon className="size-5 shrink-0" /> : null}
			<span>
				Published:{" "}
				<time dateTime={createdAt}>{formatContentDate(createdAt)}</time>
			</span>
			{showUpdated ? (
				<>
					<span aria-hidden="true">·</span>
					<span>
						Updated:{" "}
						<time dateTime={updatedAt}>{formatContentDate(updatedAt)}</time>
					</span>
				</>
			) : null}
		</p>
	);
};

export default ContentDates;
